export function formatViewers(count) {
  if (count < 1000) return count.toString();
  if (count < 1_000_000) return (count / 1000).toFixed(count % 1000 === 0 ? 0 : 1) + 'к';
  return (count / 1_000_000).toFixed(count % 1_000_000 === 0 ? 0 : 1) + 'м';
}